<div class="box">
  <div class="cat">
    <div class="head"></div>
    <div class="body"></div>
    <div class="foots"></div>
    <div class="tail"></div>
  </div>
  <div class="wool"></div>
</div>
